import { useEffect, useState } from 'react';
import { Space, Table, Button, Alert, Modal, Popconfirm, Tag  } from 'antd';
import { DeleteOutlined, DislikeOutlined, EditOutlined, LikeOutlined, PlusOutlined } from '@ant-design/icons';
import { addIntervention, deleteIntervention, getListeIntervention, updateEtatIntervention, updateIntervention } from '../../../data/params/intervention';
import {DateUserListe} from "../../../components/layout/pageData/DateUserListe";



const Intervention = () => {
  const [interventions, setInterventions] = useState([])
  const [intervention, setIntervention] = useState([])
  const [error, setError] = useState(false)
  const [message, setMessage] = useState('')
  const [libelle, setLibelle] = useState('') 
  const [description, setDescription] = useState('') 
  const [search, setSearch] = useState('') 
  const [loading, setLoading] = useState(false) 
  const [open, setOpen] = useState(false);
  const [edite, setEdite] = useState(false);

  const columns = [
    {
      title: '#',
      render: (text, record, index) => <span className='display-block chart-blue'>{ index+1 }</span>
    },
    {
      title: 'Libelle',
      dataIndex: 'libelle',
      key: 'libelle',
      render: (text) => <span className='display-block bold'>{text}</span>,
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Etat',
      dataIndex: 'etat',
      key: 'etat',
      render: (_, record) =>  record.etat === 1 ? <Tag color="green">Activé</Tag> : <Tag color="red">Désactivé</Tag>
    },
    {
      title: 'Créée le / Par',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (_, record, index) => <DateUserListe date={record.createdAt} user={record.nom_user+" "+record.prenom_user} key={index} />
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => selectIntervention(record.id)}
          />

          {record.etat === 0 && <Popconfirm
            title={`Activer la période ${record.libelle} ?`}
            description={`Voulez vous vraiment activer la période ${record.libelle} ?`}
            onConfirm={() => handleUpdateEtatIntervention(record.id, 1)}
            okText="Oui"
            cancelText="Non"
          >
            <Button
              icon={<DislikeOutlined />}
              className='chart-bg-orange'
              title='Activer ?'
            />
          </Popconfirm>}

          {record.etat === 1 && <Popconfirm
            title={`Désactiver la période ${record.libelle} ?`}
            description={`Voulez vous vraiment désactiver la période ${record.libelle} ?`}
            onConfirm={() => handleUpdateEtatIntervention(record.id, 0)}
            okText="Oui"
            cancelText="Non"
          >
            <Button
              icon={<LikeOutlined />}  
              className='chart-bg-green'
              title='Désactiver ?'
            />
          </Popconfirm>}

          <Popconfirm
            title={`Supprimer la période ${record.libelle} ?`}
            description={`Voulez vous vraiment supprimer la période ${record.libelle} ?`}
            onConfirm={() => handleDeleteIntervention(record.id)}
            okText="Oui"
            cancelText="Non"
          >
            <Button
              title='Supprimer ?'
              type="primary"
              icon={<DeleteOutlined />}
              danger  
            />
          </Popconfirm>
          
        </Space>
      ),
    },
  ];


  const filteredItems = interventions.filter(
    (item) =>
      item.libelle.toLowerCase().includes(search.toLowerCase()) ||
      item.description.toLowerCase().includes(search.toLowerCase()) ||
      item.id === parseInt(search)
  )

  const showModal = () => {
    setOpen(true);
  };
    
  const handleAddIntervention = async () => {
    setLoading(true);
    const data = { libelle, description }
    console.log(data)
    const { status, message } = await addIntervention(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setLibelle('')
      setDescription('')
      handleListeIntervention()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  };

  const handleModifierIntervention = async () => {
    setLoading(true);
    const data = { intervention_id:intervention.id, libelle, description }
    console.log(data)
    const { status, message } = await updateIntervention(data)
    setMessage(message)
    if (status === 'success') {
        setError(false)
        setLibelle('')
        setDescription('')
        handleListeIntervention()
        setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  };

    const handleCancel = () => {
        setOpen(false);
        setEdite(false)
        setLibelle('')
      setDescription('')
      setError(false)
    };

  const selectIntervention = (intervention_id) => {
    const privil = interventions.filter(periode => periode.id === intervention_id)[0]
    setIntervention(privil)
    setLibelle(privil.libelle)
    setDescription(privil.description)
    setEdite(true)
    setOpen(true);
  }


  const handleListeIntervention = async () => {
    setLoading(true)
    const { result, status, message } = await getListeIntervention()
    setMessage(message)
    if (status === 'success') {
      setError(false)
      setInterventions(result)
      handleCancel()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  const handleDeleteIntervention = async (intervention_id) => {
    setLoading(true)
    const data = {intervention_id}
    const { status, message } = await deleteIntervention(data)
    setMessage(message)
    if (status === 'success') {
      setError(false)
      handleListeIntervention()
      setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }


  const handleUpdateEtatIntervention = async (intervention_id, etat) => {
    setLoading(true)
    const data = {intervention_id, etat}
    const { status, message } = await updateEtatIntervention(data)
    setMessage(message)
    if (status === 'success') {
        setError(false)
        setLibelle('')
        setDescription('')
        handleListeIntervention()
        setLoading(false)
    } else {
      setError(true)
      setLoading(false)
    }
  }

  // const handleSearchDesCivilite = () => {
  //   const civs = interventions.filter(civilite => civilite.id == )

  // }

  useEffect(() => {
    handleListeIntervention()
  }, [])


  return (
    <>
      <div className="card mb-5 mb-lg-10 w-100">
        {error === true &&
          <Space
            direction="vertical"
            style={{
              width: '100%',
            }}
          >
            <Alert
              message="Error"
              description={message}
              type="error"
              showIcon
              
            />
          </Space>
        }
        
        <div className="card-header">
            
          <div className="card-title">
            <h3>Liste des interventions</h3>
          </div>
    
          <div className="card-toolbar">
            <div className="my-1 me-4">

              <input type="text" name="fname" onChange={e => setSearch(e.target.value)} className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" placeholder="Rechercher" />
                
            </div>

            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={showModal}
              size='large'
            >
              Ajouter
            </Button>
            {/* <a href="#" className="btn btn-sm btn-primary my-1">View All</a> */}
          </div>
            
        </div>
                
        <div className="card-body p-0">
            
            <div className="table-responsive">
                
              <Table loading={loading} columns={columns} dataSource={filteredItems} pagination= { {current: 1, pageSize: 50} } />
                
            </div>
            
        </div>
                
      </div>

      <Modal
        open={open}
        title={!edite ? "Enregistrer une nouvelle intervention" : "Modifier la intervention" }
        onOk={ !edite ? handleAddIntervention : handleModifierIntervention }
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            Annuler
          </Button>,
          <Button key="submit" type="primary" loading={loading} onClick={ !edite ? handleAddIntervention : handleModifierIntervention }>
            Enregistrer
          </Button>,
        ]}
      >
        
        {error === true && <Space
          direction="vertical"
          style={{
            width: '100%',
          }}
        >
          <Alert message={message} type="error" showIcon />

        </Space>}
        <p>
          <label className='bold'>Libelle</label>
          <input type="text" name="fname" className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" onChange={e => setLibelle(e.target.value)} value={libelle} placeholder="Entrez le libelle" />
        </p>
        <p>
          <label className='bold'>Description</label>
          <input type="text" name="fname" className="form-control form-control-lg form-control-solid mb-3 mb-lg-0" onChange={e => setDescription(e.target.value)} value={description} placeholder="Entrez la description" />
        </p>
      </Modal>
    </>
  )

}

export default Intervention
